import { format, parseISO } from 'date-fns';
import React from 'react';

const FIFTEEN_MINUTES_IN_MILLIS = 900000;

export const previewTime = (time: string, timePrefix: string): string => {
  const date = format(parseISO(time), 'dd.MM.yyyy');
  const startTime = format(parseISO(time), 'HH.mm');
  const endTime = format(parseISO(time).getTime() + FIFTEEN_MINUTES_IN_MILLIS, 'HH.mm');

  return `${date} ${timePrefix} ${startTime} - ${endTime}`;
};

export const renderLabelAndValue = (label: string, value: string): React.JSX.Element => (
  <div className="text__margin-double">
    <p className="text-small">{label}</p>
    <p>{value}</p>
  </div>
);
